import { render, staticRenderFns } from "./ShiftModal.vue?vue&type=template&id=24829c95&scoped=true"
import script from "./ShiftModal.vue?vue&type=script&lang=js"
export * from "./ShiftModal.vue?vue&type=script&lang=js"
import style0 from "./ShiftModal.vue?vue&type=style&index=0&id=24829c95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24829c95",
  null
  
)

export default component.exports